import React from 'react';
import { Card, Button, Typography } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import AuthLayout from '../../layouts/AuthLayout';
import { PRIVACY_TITLE, PRIVACY_HTML } from './privacyPolicyContent';
import '../../styles/legal.css';

const { Title } = Typography;

export default function PrivacyPolicyPage() {
  const navigate = useNavigate();

  const cardStyle = {
    width: '100%',
    maxWidth: 800,
    minWidth: 0,
    borderRadius: 16,
    boxShadow: '0 8px 24px rgba(0,0,0,0.08)',
  };

  return (
    <AuthLayout>
      <Card
        style={cardStyle}
        styles={{
          body: { padding: 32 },
          title: { whiteSpace: 'normal', overflow: 'visible', textOverflow: 'unset' },
        }}
        title={
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8, width: '100%', minWidth: 0 }}>
            <Button
              type="text"
              icon={<ArrowLeftOutlined />}
              onClick={() => navigate('/login')}
              style={{ padding: 0, flex: '0 0 auto' }}
            />
            <Title level={3} style={{ margin: 0, minWidth: 0, whiteSpace: 'normal' }}>
              {PRIVACY_TITLE}
            </Title>
          </div>
        }
      >
        <div
          className="legal-container"
          dangerouslySetInnerHTML={{ __html: PRIVACY_HTML }}
        />

        <div style={{ marginTop: 32, textAlign: 'center' }}>
          <Button
            type="primary"
            icon={<ArrowLeftOutlined />}
            onClick={() => navigate('/login')}
            size="large"
          >
            Regresar al Login
          </Button>
        </div>
      </Card>
    </AuthLayout>
  );
}
